import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserInfo, Test, Login, Signup } from "./Containers";
import { User, AddTest, AllTests, EditTest, Error404 } from "./Containers"
import { NewTests, MyTestAttempts } from "./Components"
import { ToastContainer } from 'react-toastify';
import React from 'react';
import { useEffect, useState } from 'react';
import { useRef } from 'react';
import lottie from 'lottie-web';
import axios from 'axios';
import { USER_API } from './functions';
import Swal from 'sweetalert2';


const FirstFetch = () => {
  const ref = useRef(null);
  useEffect(() => {
    const Animator = lottie.loadAnimation({
      container: ref.current,
      animationData: require('./Components/Animations/FirstFetch'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });
    return () => Animator.destroy();
  }, [])


  return (
    <div className='flex items-center align-middle flex-col h-screen p-3'>
      <div ref={ref} className='w-[min(90vw,40rem)]'></div>
      <h2 className='text-3xl font-semibold text-gray-700'>We are using Free Services, that's why it takes time to load.</h2>
      <br></br>
      <h4 className=' text-gray-500'>It will take 30-45 seconds to load after 15 min of inactivity [by Render.com]</h4>
    </div>
  )
}
function App() {
  const [loading, setLoading] = useState(true);
  const LoadReq = async () => {
    try {
      const res = await axios.get(`${USER_API}/Check`);
      console.log(res);
      if (res.status === 200) {
        setLoading(false);
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Slow Internet Connection or Server Down',
          text: 'Please check your internet connection and refresh the page',
          confirmButtonText: 'Refresh',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        })
      }
    }
    catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Slow Internet Connection or Server Down',
        text: 'Please check your internet connection and refresh the page',
        confirmButtonText: 'Refresh',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      })
    }
  }
  useEffect(() => {
    LoadReq();
  }, [])
  if (loading) {
    return <FirstFetch />
  }
  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ width: "100%", maxWidth: "500px" }}
      />
      <Routes>
        <Route path="/" element={<UserInfo />} />
        <Route path="/login" element={<Login />} />

        <Route path="/register" element={<Signup />} />
        <Route path="/MyTests" element={<MyTestAttempts />} />
        <Route path="/NewTests" element={<NewTests />} />
        <Route path="/test" element={<Test />} />


        <Route path="/Admin" element={<User />} />
        <Route path="/Admin/AllTests" element={<AllTests />} />
        <Route path="/Admin/test" element={<AddTest />} />
        <Route path="/Admin/editTest/:id" element={<EditTest />} />

        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );

}

// <a href="https://storyset.com/user">User illustrations by Storyset</a>

export default App;